(function () {
    'use strict';

    angular
        .module('app')
        .controller('SubjectsListController', SubjectsListController);

    SubjectsListController.$inject = ['API', 'alert', 'debug', 'ListViewSearchExtension'];

    function SubjectsListController(API, alert, debug, ListViewSearchExtension) {
        var vm = this;
        ListViewSearchExtension.extendScope(vm);
        vm.searchTerm = '';
        vm.listObject.filter = {};
        vm.listMeta = {};
        vm.loadingState = {
            subjectIsLoading: false
        };
        vm.loadResources = loadResources;
        vm.subjects = [];


        activate();

        function activate() {
            loadResources();
        }

        function loadResources(skipCharacterLimit) {
            var searchObject = {
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
            };

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
            }

            var promise = API.Subject.search(searchObject).$promise;

            vm.onSearch();

            if (promise) {
                vm.loadingState.subjectIsLoading = true;
                promise.then(function (response) {
                    vm.subjects = response.items;
                    debug.log(response);
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                    .finally(function() {
                        vm.loadingState.subjectIsLoading = false;
                    });
            }
        }
    }
})();